<span *ngIf="status" [class]="currentStatus?.color + ' badge' " class="badge">
  {{ (currentStatus?.label ?? '') | translate }}
</span>